import React from 'react';

import './WpMenuDivider.scss';

const WpMenuDivider = () => {
  return <li className="WpMenuDivider" />;
};

export default WpMenuDivider;
